import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors) => ({
  container: {
    paddingHorizontal: theme.spacing[4],
    paddingVertical: theme.spacing[3],
    backgroundColor: colors.backgroundL1Alpha,
    borderRadius: theme.borderRadius.s,
    alignItems: 'center',
    gap: theme.spacing[2],
  },
  // Let the text wrap inside the panel rather than overflow it.
  message: {
    flex: 1,
  },
}));
